import * as API from './index'

export default {
    upload:data=> {  return API.POSTFORM('/api/TeamAttachment/Upload', data)      
    },
    download:params=>{
        return API.GETBlog2('/api/TeamAttachment/Download', params)
    },    
     downloadFile:params=>{
        return API.GETBlog2('/api/TeamAttachment/DownloadFile', params)
    },   
    list:params=>{
        return API.GET('/api/TeamAttachment/List', params)
    }, 
    del:params=>{
        return API.DELETE('/api/TeamAttachment/Delete', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/teamattachment.js